import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function Editsupplier() {

  const {id}=useParams();
  const [errorMsg, seterrorMsg] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');
  const [registerFormData, setRegisterFormData] = useState({
        "name":'',
        "person":'',
        "address":'',
        "gst":'',
        "mobile":'',
        "landline":'',
        "email":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'edit-supplier/'+id)
            .then(function (response) {
                setRegisterFormData({
                    name:response.data.name,
                    person:response.data.person,
                    gst:response.data.gst,
                    landline:response.data.landline,
                    mobile:response.data.mobile,
                    address:response.data.address,
                    email:response.data.email,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);
  const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
  };

  const submitHandler = (e) => {
     e.preventDefault();
        const formData = new FormData();
        formData.append('name',registerFormData.name);
        formData.append('person',registerFormData.person);
        formData.append('gst',registerFormData.gst);
        formData.append('landline',registerFormData.landline);
        formData.append('mobile',registerFormData.mobile);
        formData.append('address',registerFormData.address);
        formData.append('email',registerFormData.email);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.put(baseUrl+'edit-supplier/'+id, formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'supplier has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/add-supplier/';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add supplier. Please try again later.',
                    'error'
                  );
              });
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Update supplier</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="supplier" className="form-label">supplier Name</label>
                            <input type="text" placeholder="supplier Name" className="form-control"
                               name="name" value={registerFormData.name} onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="person" className="form-label">person</label>
                            <input type="text" placeholder="person" className="form-control"
                               name="person" value={registerFormData.person} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-4 mb-3">
                            <label htmlFor="Mobile" className="form-label">Mobile</label>
                            <input type="number" maxLength={10} placeholder="Mobile" className="form-control"
                                name="mobile" value={registerFormData.mobile} onChange={inputHandler} />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label htmlFor="landline" className="form-label">landline</label>
                            <input type="number" maxLength={10} placeholder="landline" className="form-control"
                                name="landline" value={registerFormData.landline} onChange={inputHandler} />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label htmlFor="gst" className="form-label">gst</label>
                            <input type="number" maxLength={10} placeholder="gst" className="form-control"
                                name="gst" value={registerFormData.gst} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Address" className="form-label">Address</label>
                            <input type="text" placeholder="Address" className="form-control"
                               name="address" value={registerFormData.address} onChange={inputHandler} />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input type="email" placeholder="Email" className="form-control"
                               name="email" value={registerFormData.email} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Update</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default Editsupplier;
